import React from 'react'
import {
    fullExperienceData,
    benefitsIcons
} from 'pages/DetailProduct/data/full-experience'

import { useMobile } from 'utils/mobile'
import { colors } from 'styles/colors'

import Button from 'components/Button'

import { Container, Desc, Title, Header, LinkNoMobile } from './style'

import {
    Benefits,
    Content,
    Item,
    ItemDesc,
    ItemTitle,
    List,
    StyledAccordion
} from './ProductTudoFullExperience.style'

const ProductTudoFullExperience = () => {
    const mobile = useMobile()

    return (
        <Container>
            <Header>
                <Title>Na prática uma experiência completa </Title>
                <Desc>
                    Todas as soluções que a sua empresa precisa em um único
                    cartão, com a flexibilidade Alelo
                </Desc>
            </Header>
            <Content>
                <Benefits>
                    {benefitsIcons.map((benefit) => (
                        <div key={benefit}>
                            <img src={benefit} alt="Benefício" />
                        </div>
                    ))}
                </Benefits>
                {mobile ? (
                    <List>
                        {fullExperienceData
                            .filter((exp) => exp.title)
                            .map((exp) => (
                                <StyledAccordion
                                    key={exp.title}
                                    title={exp.title}
                                    color={colors.darkGreen}
                                    showArrow
                                >
                                    <div>{exp.desc}</div>
                                </StyledAccordion>
                            ))}
                    </List>
                ) : (
                    <List>
                        {fullExperienceData.map((exp) => (
                            <Item key={exp.title}>
                                {exp.title && (
                                    <ItemTitle>{exp.title}</ItemTitle>
                                )}
                                {exp.desc && <ItemDesc>{exp.desc}</ItemDesc>}
                            </Item>
                        ))}
                    </List>
                )}
                <LinkNoMobile href="#">
                    <Button kind="add">Eu quero</Button>
                </LinkNoMobile>
            </Content>
        </Container>
    )
}

export default ProductTudoFullExperience
